const getPercent = (num, toFixed = 2) => {
  if (!num || Number.isNaN(num)) {
    return '0%';
  }

  return `${parseFloat((num * 100).toFixed(toFixed))}%`;
};

export default getPercent;
